import React from "react";
import { COLORS } from "@app/constants";
import { useTranslation } from "react-i18next";
import { Text, View } from "@/styles/reactnative";
import { QuantityCosts } from "../styles";
import styled from "styled-components";

const QuantityCostFormList = ({ title, bids, asks, type }) => {
  const { t } = useTranslation();

  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <Text style={{ color: COLORS.lightGray5, fontSize: 12 }}>
        {/*{title && t(title)}*/}
        {title}
      </Text>

      <ValueWrap>
        <QuantityCosts>
          <div style={{display: 'flex', gap: 4}}>
            <Text style={{ color: COLORS.lightGreen, fontSize: 12 }}>{bids}</Text>
          </div>
          <Text style={{ color: COLORS.lightRed, fontSize: 12 }}>{asks}</Text>
        </QuantityCosts>
        <Text style={{ fontSize: 12 }}>{type}</Text>
      </ValueWrap>
    </View>
  );
};

export default QuantityCostFormList;


const ValueWrap = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
`